module.exports = __webpack_public_path__ + "vue/img/aicon (22).20c857ad.png";